import store from '../../../global-state/redux';

// local helper function to get core object:
const getCore = () => store.getState().appState.core;

export const getEventId = () => getCore()?.event_id;
export const getAppId = () => getCore()?.app_ids;
export const getServerAddr = () => getCore()?.server_addr;
